import * as url from "../url.helper";

import { post } from "../api.helper";

export const getBank = data => post(url.BANK_LIST, data);

export const addBankDetails = data => post(url.ADD_BANK_DETAILS, data);

export const getBankDetails = data => post(url.GET_BANK_DETAILS, data);

export const editBankDetails = data => post(url.EDIT_BANK_DETAILS, data);

